import React, { useEffect, useState } from 'react';

const TechnicalSkillsModal = ({ isOpen, onClose, initialTitle = '', initialDetails = '', onSave, onEnhance }) => {
  const [title, setTitle] = useState(initialTitle || '');
  const [details, setDetails] = useState(initialDetails || '');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTitle(initialTitle || '');
    setDetails(initialDetails || '');
  }, [initialTitle, initialDetails, isOpen]);

  if (!isOpen) return null;

  const handleEnhance = async () => {
    if (!onEnhance) return;
    try {
      setLoading(true);
      const enhanced = await onEnhance(details || '');
      if (enhanced) setDetails(enhanced);
    } catch (err) {
      console.error('TechnicalSkillsModal enhance error', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = () => {
    if (onSave) onSave({ title: title || '', details: details || '' });
  };

  return (
    <div style={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, background: 'rgba(0,0,0,0.4)' }}>
      <div style={{ width: 720, maxWidth: '95%', background: '#fff', borderRadius: 6, padding: 20, boxShadow: 'rgba(0,0,0,0.2) 0px 6px 24px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h3 style={{ margin: 0 }}>Edit Technical Skill Section</h3>
          <button aria-label="Close" onClick={onClose} style={{ background: 'transparent', border: 'none', fontSize: 20 }}>×</button>
        </div>

        <label className="form-label" style={{ display: 'block', marginBottom: 6 }}>Section title</label>
        <input
          type="text"
          placeholder="Section title (e.g. Programming Languages)"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="section-input"
          style={{ width: '100%', marginBottom: 8 }}
        />

        <label className="form-label" style={{ display: 'block', marginBottom: 6 }}>Skills details</label>
        <textarea
          rows={8}
          className="form-textarea"
          value={details}
          onChange={(e) => setDetails(e.target.value)}
          placeholder="Enter the skills for this section, separated by commas or bullet points"
          style={{ width: '100%' }}
        />

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12 }}>
          <button type="button" className="btn btn-secondary" onClick={handleEnhance} disabled={loading}>{loading ? 'Enhancing...' : 'Enhance'}</button>
          <button type="button" className="btn btn-primary" onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default TechnicalSkillsModal;
